export var SET_OPTIONS = 'SET_OPTIONS';
export var SET_DEFAULT_CUSTOMIZABLE = 'SET_DEFAULT_CUSTOMIZABLE';
export var RESTORE_CUSTOMIZABLE = 'RESTORE_CUSTOMIZABLE';
export var SET_SELECTED_OPTION = 'SET_SELECTED_OPTION';
export var SET_CONFIGURATOR = 'SET_CONFIGURATOR';
export var SELECT_OPTION_ITEM = 'SELECT_OPTION_ITEM';
export var SELECT_OPTION_ITEM_NESTED = 'SELECT_OPTION_ITEM_NESTED';